export enum ANALYTICS_PERMISSIONS {
    ANALYTICS_READ = 'ANALYTICS_READ',
}
